// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import * as React from 'react';
import html2canvas from 'html2canvas';
import { Spinner } from 'office-ui-fabric-react';
import {logException, logPageAction} from './../../lib/ApplicationInsights';
import CorrelationVector from './../../lib/CorrelationVector';
import { useTranslation } from 'react-i18next';

import Styles from './feedback.module.scss';

interface PropTypes {
    onScreenshotCaptured: any;
}

export default function ScreenShotGenerator(props: PropTypes) {
    const [picture, setPicture] = React.useState(undefined);
    const { t } = useTranslation();
    React.useEffect(() => {
        try {
            logPageAction('Feedback screenshot generation started');

            html2canvas(document.body, {
                allowTaint: false,
                useCORS: false,
            }).then((result: any) => {
                logPageAction('Feedback screenshot generation finished');

                const screenshotDataURL = result.toDataURL();
                setPicture(screenshotDataURL);
                props.onScreenshotCaptured(screenshotDataURL);
            });
        } catch (e) {
            logPageAction('Feedback screenshot generation failed');

            const error = new Error('Unexpected error occurred during generating screenshot');

            logException(CorrelationVector.getCurrentValue(), error, e);
        }
    }, []);
    
    if (!picture) {
        return <Spinner className={Styles.screenshot} />;
    }

    return <img className={Styles.screenshot} src={picture} alt={t('include_screenshots')} />;
}
